import type { SupWeb3VaultBalance } from "@/types";
import React from "react";

import ChipVaultAssets from "@/components/Ui/Chip/Vault/Assets";
import UiLabelTag from "@/components/Ui/Label/Tag";

import { getVaultDecimals } from "@/utils";
import config from "@/../config/dapp.config";
import * as dn from "dnum";
import Link from "next/link";
import { SupText } from "@repo/core-ui";

interface GridCellPositionNameProps {
  singlePosition: SupWeb3VaultBalance;
}

export default function GridCellPositionName({ singlePosition }: GridCellPositionNameProps) {
  const title = singlePosition.vault.friendly_name;
  const hasSuperPool = singlePosition.vault.super_pools?.length > 0;
  const isErc20 = singlePosition?.is_erc20;

  return (
    <div className="inline-flex h-[72px] items-center justify-start gap-2">
      <div className="flex w-[48px] items-center justify-center">
        <ChipVaultAssets assets={singlePosition.vault.assets} vaultId={singlePosition.vault.id} chain={singlePosition.vault.chain} useSmall showChain />
      </div>
      <div className="inline-flex shrink grow basis-0 flex-col items-start justify-start">
        <div className="inline-flex items-baseline justify-start gap-1 self-stretch">
          <SupText variant="subtitle1" className="leading-6 text-neutral-950">
            {dn.format([BigInt(`${singlePosition.superposition_balance}`), getVaultDecimals(singlePosition.vault)], {
              digits: config.decimalsBigRoundingLimit,
              locale: "en-US",
            })}
          </SupText>
          <SupText variant="caption" className="text-[11px] leading-3 tracking-[1px] text-neutral-800">
            {singlePosition.vault.symbol}
          </SupText>
        </div>
        <Link
          className="inline-flex w-full flex-auto cursor-pointer overflow-hidden text-primary-800 decoration-from-font underline-offset-2 hover:underline"
          href={`/vault/${singlePosition.vault.id}/`}
        >
          <SupText variant="caption" className="w-full uppercase leading-4">
            {title}
          </SupText>
        </Link>
        <div className="inline-flex items-center justify-start gap-1 self-stretch pt-1">
          {hasSuperPool && <UiLabelTag type="superpool" label="SUPERPOOL" />}
          {isErc20 && <UiLabelTag type="erc-20" label="ERC-20" />}
        </div>
      </div>
    </div>
  );
}
